import React, { useEffect, useRef, useState } from 'react';
import './Legal.css';
import Navbar from '../../components/Common/Navbar/Navbar';
import Header from '../../components/Common/Header/Header';
import useSectionRefs from '../../hooks/useSectionRefs';
import Footer from '../../components/Common/Footer/Footer';
import ContactLinkSection from '../../components/Common/ContactLinkSection/ContactLinkSection';
import SEO from '../../components/Common/SEO/SEO';
import LegalContent from '../../components/Common/Legal/Legal';

const Legal: React.FC = () => {
  const sectionRefs = useSectionRefs();

  
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);

  const handleOpenContactModal = () => {
    setIsContactModalOpen(true);
  };

  const handleCloseContactModal = () => {
    setIsContactModalOpen(false);
  };

  // Debug: Vérifier que les refs sont bien attachées
  useEffect(() => {
    console.log('Legal.tsx - sectionRefs:', sectionRefs);
    console.log('Legal.tsx - header ref:', sectionRefs.header?.current);
    console.log('Legal.tsx - start ref:', sectionRefs.start?.current);
    console.log('Legal.tsx - newsletter ref:', sectionRefs.newsletter?.current);
    
    // Test: forcer la détection de la section start
    const startSection = sectionRefs.start?.current;
    if (startSection) {
      console.log('Start section found:', startSection);
      console.log('Start section classes:', startSection.className);
      console.log('Start section offsetHeight:', startSection.offsetHeight);
      console.log('Start section getBoundingClientRect:', startSection.getBoundingClientRect());
    }
  }, [sectionRefs]);
  
  return (
    <div>
      <div>
        <SEO 
          title="Mentions Légales - IT-Monkeys"
          description="Mentions légales, conditions d'utilisation et politique de confidentialité d'IT-Monkeys."
          path="/legal"
        />
        
        <section id="header" className="section dark" ref={sectionRefs.header}>
          <div>
            <Navbar 
              sectionRefs={sectionRefs}
              openContactModal={handleOpenContactModal}
              closeContactModal={handleCloseContactModal}
            />
            <Header title="Mentions légales" subtitle="" />
          </div>
        </section>
        
        <section id="start" className="section light" ref={sectionRefs.start}>
          <div className="gradient-legal-bg">
            <LegalContent />
          </div>
        </section>

        <section id="newsletter" className="section dark" ref={sectionRefs.newsletter}>
          <ContactLinkSection pageKey="home" />
          <Footer />
        </section>
      </div>
      </div>
  );
};

export default Legal; 
